import { userReducer } from './User.slice';

export const getUserModule = () => ({
  id: 'UserModule',
  reducerMap: {
    user: userReducer,
  },
  sagas: [],
});
